import { Injectable, ComponentRef, Provider } from '@angular/core';
import { IAddressListDialogService, IAddressListDialogServiceToken } from 'shared/services/ui/dialogs/address-list/address-list-dialog-service.abstract';
import { AddressDto } from 'projects/shared/lib/services/INTEGRA_Shop_Client';
import { DialogBaseService } from 'projects/shared/lib/services/ui/dialog.service';
import { AddressListDialogMHComponent } from '../../components/shared/address/list-dialog/address-list-dialog.component';

@Injectable({
  providedIn: 'root',
}) export class AddressListDialogService implements IAddressListDialogService {

  addressListDialogShow(
    modalTitle: string,
    addressList: AddressDto[],
    callbackSubmit: () => void,
    callbackCancel: () => void,
    submitButtonLabel?: string,
  ) {
    DialogBaseService.dialogGenericShow(
      AddressListDialogMHComponent,
      (component: ComponentRef<AddressListDialogMHComponent>) => {
        component.instance.modalTitle = modalTitle;
        component.instance.addressList = addressList;
        if (submitButtonLabel) {
          component.instance.submitButtonLabel = submitButtonLabel;
        }

        component.instance.modalSubmit.subscribe(
          () => {
            callbackSubmit();
            DialogBaseService.dynamicComponentRemove(component);
          }
        );
        component.instance.modalCancel.subscribe(
          () => {
            callbackCancel();
            DialogBaseService.dynamicComponentRemove(component);
          }
        );
      }
    );
  }

}

/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const AddressListDialogServiceProvider: Provider[] = [
  { provide: IAddressListDialogServiceToken, useExisting: AddressListDialogService }
];

